export const COLORS = {
  GREEN: '#016623',
  LIGHT_GREEN: '#029636',
  DARK_GREEN: '#2a642c',
  LIGHT_YELLOW: '#F1C400',
  LIGHT_GREY: '#f6f7f8',
  DARK_GREY: '#adb0b1',
  DARKER_GREY: '#4a4b4c',
  RED: '#d12128',
  WHITE: 'white',
  BLACK: 'black',
  TRANSPARENT: 'transparent',
};
